import { type ReactElement, type ReactNode } from "react"
// import spinner from "../assests/images/loading.svg"

export interface SavingProps {
        title: string,
        color: string
}

export default function Saving(props: SavingProps): ReactElement {
        const labelClass = "text-center text-" + props.color;
        return <>
                <div className="flex justify-center gap-[0.5rem]">
                        <label className={labelClass}>{props.title}</label>
                        {/* <img src={spinner} /> */}
                        <div className="w-[1rem] flex items-end">
                                <svg fill={props.color} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><circle cx="4" cy="12" r="3"><animate id="spinner_qFRN" begin="0;spinner_OcgL.end+0.25s" attributeName="cy" calcMode="spline" dur="0.6s" values="12;6;12" keySplines=".33,.66,.66,1;.33,0,.66,.33" /></circle><circle cx="12" cy="12" r="3"><animate begin="spinner_qFRN.begin+0.1s" attributeName="cy" calcMode="spline" dur="0.6s" values="12;6;12" keySplines=".33,.66,.66,1;.33,0,.66,.33" /></circle><circle cx="20" cy="12" r="3"><animate id="spinner_OcgL" begin="spinner_qFRN.begin+0.2s" attributeName="cy" calcMode="spline" dur="0.6s" values="12;6;12" keySplines=".33,.66,.66,1;.33,0,.66,.33" /></circle></svg>
                        </div>

                </div>
        </>
}

